export default __webpack_public_path__ + "static/media/meta-icon.51bf4215.svg";